// extracted by mini-css-extract-plugin
export var buttonContent = "_3w-0";
export var centered = "_3w-1";
export var centeredFlex = "_3w-2";
export var errorText = "_3w-3";
export var icon = "_3w-4";
export var iconButtonContent = "_3w-5";
export var monospace = "_3w-6";
export var padded = "_3w-7";